export const environment = {
    production: true,
    VERSION: 'v0.2.0',
    API_PORT: '3000',
    STATIC_PORT: '4200',
    WS_PROTOCOL: 'ws://',
    MANUAL_URL: 'https://wiki.maintenance.maurer-rides.de'
};
